"use client";

import { useSelection } from "@frend-digital/centra/client";
import { events } from "@frend-digital/events";
import { useEffect } from "react";
import { useCartModal } from "../CartModal/CartModal";
import CartContent from "./CartContent";

const Cart = () => {
  const { isOpen } = useCartModal();
  const { data } = useSelection();

  useEffect(() => {
    if (isOpen && data?.selection) {
      events.dispatch("view_cart", data, {
        dispatcher: "centra",
      });
    }
  }, [isOpen, data]);

  return <CartContent />;
};

export default Cart;
